import { Link, useNavigate, useLocation } from 'react-router-dom';
import { seoContent } from '@/mocks/content';

export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleFooterLink = (url: string) => (e: React.MouseEvent) => {
    if (url.startsWith('#')) {
      e.preventDefault();
      const sectionId = url.replace('#', '');
      if (location.pathname === '/') {
        const el = document.getElementById(sectionId);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        navigate('/');
        setTimeout(() => {
          const el = document.getElementById(sectionId);
          if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 200);
      }
    }
  };

  return (
    <footer className="relative w-full bg-primary-900">
      <div className="w-full px-6 md:px-10 lg:px-16 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer whitespace-nowrap">
              <div className="w-8 h-8 rounded-lg bg-accent-500 flex items-center justify-center">
                <i className="ri-file-list-3-line text-white text-sm"></i>
              </div>
              <span className="font-heading text-white text-base font-semibold">
                cssbuyspreadsheet<span className="text-accent-400">.team</span>
              </span>
            </Link>
            <p className="text-primary-300/70 text-sm leading-relaxed">
              {seoContent.footerDesc}
            </p>
          </div>

          <div>
            <h4 className="text-primary-200/70 text-xs font-semibold uppercase tracking-wider mb-5">NEWSLETTER</h4>
            <p className="text-primary-300/60 text-sm leading-relaxed">
              {seoContent.newsletterHint}
            </p>
          </div>

          <div>
            <h4 className="text-primary-200/70 text-xs font-semibold uppercase tracking-wider mb-5">LINKS</h4>
            <div className="flex flex-col gap-2.5">
              {seoContent.footerLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.url}
                  onClick={handleFooterLink(link.url)}
                  className="text-primary-200 hover:text-white text-sm transition-colors cursor-pointer whitespace-nowrap"
                >
                  {link.name}
                </Link>
              ))}
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-primary-200 hover:text-white text-sm transition-colors cursor-pointer whitespace-nowrap"
              >
                Kaspreadsheet
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-primary-200/70 text-xs font-semibold uppercase tracking-wider mb-5">SOCIAL</h4>
            <div className="flex flex-col gap-2.5">
              {seoContent.footerSocial.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="flex items-center gap-2 text-primary-200 hover:text-white text-sm transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className={`${social.icon} text-sm`}></i>
                  {social.name}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="w-full px-6 md:px-10 lg:px-16 pb-8">
        <div className="overflow-hidden">
          <p className="font-heading text-6xl md:text-8xl lg:text-9xl font-black text-primary-800/25 tracking-tight leading-none select-none whitespace-nowrap">
            CSSBUYSPREADSHEET
          </p>
        </div>
      </div>

      <div className="border-t border-primary-800/40">
        <div className="w-full px-6 md:px-10 lg:px-16 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-primary-400/60 text-xs">
            © 2026 CSSBuySpreadsheet. Todos os direitos reservados.
          </p>
          <p className="text-primary-400/60 text-xs">
            Site afiliado · Links externos direcionam para kaspreadsheet.com
          </p>
        </div>
      </div>
    </footer>
  );
}